import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import {
  CategoryTextSortDto,
  ImporterDto,
  MenuDto,
  NewsDto, ResourceListOfFaqDto,
  ResourceListOfFlagDto,
  ResourceListOfGroupDto,
  ResourceListOfLanguageCnrDto,
  ResourceListOfNewsDto,
  ResourceListOfPrivilegeDto,
  ResourceListOfProMTGroupDto,
  ResourceListOfRoleDto,
  ResourceListOfSpecConfigurationDto,
  ResourceListOfUserDto,
  SpecDto,
} from 'src/services/Client';

export interface IAdministrationState {
  /** All users known to the PSL */
  users?: ResourceListOfUserDto;
  /** All groups known to the PSL */
  groups?: ResourceListOfGroupDto;
  /** All promt groups known to the PSL */
  proMTGroups: ResourceListOfProMTGroupDto;
  /** All roles known to the PSL */
  roles?: ResourceListOfRoleDto;
  /** All privileges known to the PSL */
  privileges?: ResourceListOfPrivilegeDto;
  /** All flags known to the PSL */
  flags: ResourceListOfFlagDto;
  /** Received news */
  news: ResourceListOfNewsDto;
  /** Received faq */
  faqs: ResourceListOfFaqDto;
  /** Received active news */
  activeNews: NewsDto[];
  /** Receive model year categories */
  modelyearCategories: CategoryTextSortDto[];
  /** Admin area links */
  adminAreaLinks?: MenuDto;
  /** Importers known to the back end */
  importerList?: ImporterDto[];
  /** currently selected importer */
  importer?: ImporterDto;
  /** data from Configuration Maintainance tab */
  specs?: SpecDto[];
  /** default importer to be selected in frontend */
  defaultImporter: string;
  /** Receive cnr languages */
  cnrLanguages: ResourceListOfLanguageCnrDto;

  specConfigs?: ResourceListOfSpecConfigurationDto;

  /** defaultActiveIndex for AccessTab */
  accessTabAndFilter: {
    activeIndex: number;
    filter?: string;
  };
}

const assignImporters = (
  state: IAdministrationState,
  importerList: ImporterDto[]
): void => {
  state.importerList = importerList;

  if (state.importerList !== undefined) {
    // select Porsche Deutschland as importer
    state.importer = state.importerList.find(
      (value) => value.importer.trim().toUpperCase() === state.defaultImporter
    );
    if (!state.importer && state.importerList.length > 0) {
      state.importer = state.importerList[0];
    }
  }
};

const INITIAL_STATE: IAdministrationState = {
  flags: {},
  news: {},
  faqs: {},
  activeNews: [],
  defaultImporter: 'DE',
  modelyearCategories: [],
  proMTGroups: {},
  accessTabAndFilter: {
    activeIndex: 0,
    filter: undefined,
  },
  cnrLanguages: {}
};

export const administrationReducer = (
  state: IAdministrationState = INITIAL_STATE,
  action: AnyAction
): IAdministrationState => {
  switch (action.type) {
    case ActionTypes.RECEIVE_ADMINAREA_LINKS:
      return {
        ...state,
        adminAreaLinks: action.adminAreaLinks,
      };
    case ActionTypes.RECEIVE_USERS:
      return {
        ...state,
        users: action.users,
      };
    case ActionTypes.RECEIVE_GROUPS:
      return {
        ...state,
        groups: action.groups,
      };
    case ActionTypes.RECEIVE_PROMT_GROUPS:
      return {
        ...state,
        proMTGroups: action.groups,
      };
    case ActionTypes.RECEIVE_ROLES:
      return {
        ...state,
        roles: action.roles,
      };
    case ActionTypes.RECEIVE_FLAGS:
      return {
        ...state,
        flags: action.flags,
      };
    case ActionTypes.RECEIVE_NEWS:
      return {
        ...state,
        news: action.news,
      };
    case ActionTypes.RECEIVE_FAQS:
      return {
        ...state,
        faqs: action.faqs,
      };
    case ActionTypes.RECEIVE_ACTIVE_NEWS:
      return {
        ...state,
        activeNews: [...action.news],
      };
    case ActionTypes.RECEIVE_MODELYEAR_CATEGORIES:
      return {
        ...state,
        modelyearCategories: [...action.modelyearCategories],
      };
    case ActionTypes.UNLOAD_MODELYEAR_CATEGORIES:
      return {
        ...state,
        modelyearCategories: [],
      };
    case ActionTypes.RECEIVE_PRIVILEGES:
      return {
        ...state,
        privileges: { ...action.privileges },
      };
    case ActionTypes.RECEIVE_SPECS:
      return {
        ...state,
        specs: action.specs,
      };
    case ActionTypes.RECEIVE_SPEC_CONFIGS:
      return {
        ...state,
        specConfigs: action.data,
      };
    case ActionTypes.RECEIVE_IMPORTER_LIST:
      assignImporters(state, action.importerList);
      return {
        ...state,
        importerList: action.importerList,
      };
    case ActionTypes.CHANGE_ACTIVE_ACCESSTAB:
      return {
        ...state,
        accessTabAndFilter: action.payload,
      };
    case ActionTypes.RECEIVE_CNR_LANGUAGES:
      return {
        ...state,
        cnrLanguages: action.cnrlanguages
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/adminstrationReducer.ts